import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ModalUI } from '../../common';

const ModalCambiarMetodo = (props) => {
  let { handleSubmit, modalHandler, modal_state, form_state } = props;

  return (
    <ModalUI
      open={modal_state}
      id="desactivar_metodo"
      title="Cambiar método de pago"
      modalHandler={modalHandler}
      aditional_param="desactivar_metodo"
      handleSubmit={handleSubmit}
      button_label="Desactivar"
      button_disabled={false}
      button_loading={form_state}
    >
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <Typography>
            Para cambiar de método de pago debes desactivar el método de pago
            actual, luego podrás elegir nuevamente tu otro método de pago.
          </Typography>
        </Grid>
      </Grid>
    </ModalUI>
  );
};

export { ModalCambiarMetodo };
